<template>
  <el-dialog
      ref="dialog"
      v-dialog-drag
      title="导出日志查询(仅支持查询最近100次导出情况)"
      :visible.sync="visible"
      width="60%"
      @open="open"
  >
    <div style="margin-top: 10px;"/>
    <div style="overflow: auto;height: 400px">
      <el-table ref="tree" :data="treeData" row-key="id" border
      >
        <el-table-column label="序号" prop="index" width="75"/>
        <el-table-column label="日期" prop="createTime" width="160"/>
        <el-table-column label="导出操作情况" prop="infos" width=""/>
      </el-table>
    </div>
    <template slot="footer">
      <el-button @click="visible=false">关闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      treeData: [],

    }
  },
  watch: {},
  methods: {
    async open(data) {
      this.visible = true
      if(data&&data.length>0) {
        this.treeData = data
        let index = 1;
        this.treeData.forEach(item => item.index = index++)
      }
    },
  }
}
</script>

<style scoped>

</style>
